module.exports = __webpack_public_path__ + "img/dash-21022022.ca8c2e19.svg";